import { post } from '@/filter/http'
import coreApi from './coreApi'
import ies5Api from './ies5Api'
import bbApi from './bbApi'
import googleApi from './googleApi'
export default {
  //IM相关：发送消息
  tomessage: function (url, data) {
    return post(url, data)
  },
  coreApi,
  ies5Api,
  bbApi,
  googleApi
}
